<template>
    <div class="inner-wrap">
        <div class="left" :style="{'height': height}">
            <div class="tab-list">
                <div :class="{ active: current_tab1 === 'default' }" style="" class="cursor tab-item" @click="change_tab1('default')">Platform Accessories</div>
                <div class="shu"></div>
                <div :class="{ active: current_tab1 === 'self' }" style="" class="cursor tab-item" @click="change_tab1('self')">Self-provided Accessories</div>
            </div>
            <div class="mlist" v-show="current_tab1==='default'">
                <div class="item" v-for="(v, k) in form_data.accessory" :key="`a` + k">
                    <div class="img-wrap">
                        <img :src="v.image" alt="" class="img" v-viewer>
                    </div>

                    <div class="r1">
                        <div class="name">{{ v.accessory_name_en }}</div>
                        <div class="tag-list">
                            <div class="tag-item" style="width: 100%">
                                <span class="key" >No.:</span>
                                <span class="value">{{v.accessory_sku}}</span>
                            </div>
                            <div class="tag-item" style="width: 100%">
                                <span class="key">Unit:</span>
                                <span class="value">{{v.measure_unit_en || ''}}</span>
                            </div>
                            <div class="tag-item" style="width: 100%;border-bottom: 1px solid #E6E6E6;">
                                <span class="key">Quantity:</span>
                                <input class="value" :value="form_data.accessory[k].num" @input="input2($event, 'accessory', k, 'num')" placeholder="个数" type="text"/>
                            </div>
                            <div class="tag-item">
                                <span class="key">Color:</span>
                                <select class="value" :value="form_data.accessory[k].color_key" @input="change3($event, 'accessory', k, 'color_key')">
                                    <option v-for="(vv) in form_data.accessory[k].color_list" :value="vv.color_key">{{vv.color_name_en}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label >Usage Instructions</label>
                        <input :value="form_data.accessory[k].desc" @input="input2($event, 'accessory', k, 'desc')" placeholder="Usage Instructions" type="text" class="desc" />
                    </div>
                    <img src="@/assets/images/design/icon-del.png" class="icon-del cursor" @click.prevent="del_accessory(k)" />
                </div>
            </div>


            <div class="mlist2" v-show="current_tab1==='self'">
                <div class="item" v-for="(v, k) in form_data.accessory_self" :key="`ms` + k">
                    <div class="img-wrap ">
                        <Upload
                                :action="upload_url"
                                :data="{ dir: 'template' }"
                                :on-success="(response, file, fileList) =>handleSuccess(response, file, fileList, k)"
                                :show-upload-list="false"
                                :format="['jpg','jpeg','png','gif']"
                                accept=".jpg,.jpeg,.png,.gif"
                        >
                            <template v-if="v.image">
                                <div class="img-box">
                                    <img @click.stop :src="v.image" class="img" v-viewer />
                                    <div class="replace-btn">
                                        <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                        <div class="text">Re-upload</div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="img-default cursor">
                                    <img class="img2" src="@/assets/images/design/icon-add.png"/>
                                    <p>Upload</p>
                                </div>
                            </template>
                        </Upload>
                    </div>

                    <div class="r1">
                        <div class="tag-list">
                            <div class="tag-item" >
                                <span class="key" >Name：</span>
                                <input class="value" :value="form_data.accessory_self[k].accessory_name" @input="input2($event, 'accessory_self', k, 'accessory_name')" placeholder="Accessory Name" type="text"/>
                            </div>
                            <div class="tag-item" >
                                <span class="key" >No.：</span>
                                <input class="value" :value="form_data.accessory_self[k].accessory_sku" @input="input2($event, 'accessory_self', k, 'accessory_sku')" placeholder="Accessory No." type="text"/>
                            </div>
                            <div class="tag-item">
                                <span class="key">Unit：</span>
                                <input class="value" :value="form_data.accessory_self[k].measure_unit_en" @input="input2($event, 'accessory_self', k, 'measure_unit_en')" placeholder="Specification" type="text"/>
                            </div>
                            <div class="tag-item" >
                                <span class="key">Quantity：</span>
                                <input class="value" :value="form_data.accessory_self[k].num" @input="input2($event, 'accessory_self', k, 'num')" placeholder="Quantity" type="text"/>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label >Usage Introductions</label>
                        <input :value="form_data.accessory_self[k].desc" @input="input2($event, 'accessory_self', k, 'desc')" placeholder="Usage Instructions" class="desc" type="text"/>
                    </div>
                    <img src="@/assets/images/design/icon-del.png" class="icon-del cursor" @click.prevent="del_accessory_self(k)" />
                </div>

                <div class="btn-continue cursor" @click="add_accessory_self">
                    + Add Accessory
                </div>
            </div>

        </div>

        <!-- :style="{width: width}"  -->
        <div class="right">
            <template v-if="is_lesson_show">
                <Lesson ></Lesson>
            </template>
            <template v-else>
                <!-- :style="{'height': height, overflow: 'auto'}" -->
                <div class="material-wrap">
                    <div class="top">
                        <h2>Accessory Selection</h2>
                        <div class="input-wrap">
                            <input v-model="form_data_accessory.keyword" placeholder="Enter keywords to search accessories" type="text" @keyup.enter="search_accessory"/>
                            <img alt="" class="icon-search" src="@/assets/images/icon-search.png" @click="search_accessory"/>
                        </div>
                    </div>
                    <div class="content">
                        <div class="left category-list">
                            <div v-for="(v, k) in accessory_category_list" :key="`dc` + k" :class="{active: current_accessory_category_id === v.accessory_category_id}" class="category-item cursor" @click="choose_accessory_category(v)">
                                {{ v.category_name_en }}
                            </div>
                        </div>
                        <div class="right-content">
                            <div v-for="(v, k) in accessory_label_list" :key="`lf1` + k" class="label-list">
                                <div class="label-item">
                                    <p>{{ v.label_name_en }}：</p>
                                </div>
                                <div
                                        v-for="(vv, kk) in v.content_en"
                                        :key="`lf2` + kk"
                                        :class="{ active: accessory_label_ids.includes(vv.id) }"
                                        class="label-item"
                                        @click="choose_label(vv)"
                                >
                                    <p>{{ vv.name }}</p>
                                </div>
                            </div>
                            <div v-show="sub_accessory_category_list.length > 0" class="sub-list">
                                <div
                                        v-for="(v, k) in sub_accessory_category_list"
                                        :key="`fpsa` + k"
                                        :class="{active:current_sub_accessory_category_id === v.accessory_category_id,}"
                                        class="sub-item"
                                        @click="choose_sub_accessory_category(v)"
                                >
                                    <p>{{ v.category_name_en }}</p>
                                </div>
                            </div>
                            <template v-if="accessory_list.length > 0">
                                <div class="fabric-list">
                                    <div
                                            v-for="(v, k) in accessory_list"
                                            :key="`df` + k"
                                            :class="{ active: selected_ids.includes(v.id)}"
                                            class="fabric-item"
                                            @click="toggle_accessory(v)"
                                    >
                                        <img :src="v.image | default_img" alt="" />
                                        <p>{{ v.accessory_name_en }}</p>
                                        <img v-show="selected_ids.includes(v.id)" alt="" class="icon-check" src="@/assets/images/icon-check.png"/>
                                        <div class="mask">
                                            <div class="btn">
                                                <span class="fa-detail" @click.stop="open_accessory_detail(v)">View</span>
                                                <span class="fa-choose" @click.stop="toggle_accessory(v)"> {{selected_ids.includes(v.id) ? 'Cancel':'Select'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Page :current="form_data_accessory.page" v-if="total>0" :page-size="form_data_accessory.size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  ></Page>
                            </template>
                            <template v-else>
                                <img class="no-data" :src="require(`@/assets/images/no-data.png`)" alt="">
                            </template>
                        </div>
                    </div>
                    <div v-show="is_color_show" class="color-mask">
                        <div class="color-wrap">
                            <h2 class="title">Color Selection</h2>
                            <div class="color-list">
                                <div v-for="(v, k) in current_temp_accessory.color_list"
                                     :class="{active: current_temp_accessory.color_id === v.color_id}"
                                     class="color-item"
                                     @click="choose_color(v)" :key="k"
                                >
                                    <img v-viewer @click.stop :src="v.color_value|default_img" alt="" />
                                    <span class="name">{{ v.color_name_en }}</span>
                                </div>
                            </div>
                            <div class="btn-group">
                                <div class="btn btn-cancel" @click="close_color_modal">Cancel</div>
                                <div class="btn btn-confirm" @click="confirm_color">Confirm</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <popup :show.sync="is_popup_show_detail" height="680px" width="980px" @on-close="close_accessory_detail">
            <div class="fabric-content-wrap" style="height:100% !important;">
                <div class="info-wrap">
                    <div class="left-popup">
                        <div v-if="current_temp_accessory.image_list.length > 0 || current_temp_accessory.video" class="slider">
                            <swiper ref="swiper" :options="swiperOption">
                                <swiper-slide v-if="current_temp_accessory.video">
                                    <video v-if="current_temp_accessory.video" :src="current_temp_accessory.video" muted autoplay controls id="video-accessory" >您的浏览器不支持视频播放。</video>
                                </swiper-slide>
                                <swiper-slide
                                        v-for="(item, index) in current_temp_accessory.image_list"
                                        :key="`sl` + index"
                                >
                                    <img :src="item.url" class="f-img" v-viewer />
                                </swiper-slide>
                                <!--                                    <div class="swiper-pagination" slot="pagination"></div>-->
                                <div slot="button-prev" class="swiper-button-prev"></div>
                                <div slot="button-next" class="swiper-button-next"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="right">
                        <p class="name">{{ current_temp_accessory.accessory_name_en }}</p>
                        <p class="no">Accessory No.:{{ current_temp_accessory.accessory_sku }}</p>
                        <div class="title" style="border-top: 1px solid #e0e0e0">
                            <!-- 辅料参数 -->
                        </div>
                        <div class="list">
                            <div class="item">
                                <span class="key">Unit：</span
                                ><span class="value">{{ current_temp_accessory.measure_unit_en || '' }}</span>
                            </div>
                            <div class="item">
                                <span class="key">Specification：</span
                                ><span class="value">{{ current_temp_accessory.spec }}</span>
                            </div>
                            <div class="item">
                                <span class="key">Material：</span
                                ><span class="value">{{ current_temp_accessory.material_en }}</span>
                            </div>
                            <div class="color-box">
                                <div v-for="(item,index) in current_temp_accessory.color_list" :key="index" @click="choose_color(item)" :class="['color-item',{active:current_temp_accessory.color_id === item.color_id}]">
                                    <img v-viewer @click.stop :src="item.color_value|default_img" alt="" class="color-img" />{{ item.color_name_en }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title-box">
                    <div class="title">Product Details</div>
                    <div class="line"></div>
                </div>
                <div class="richtext-wrap" v-html="current_temp_accessory.description"></div>
                <div class="btn-box">
                    <button class="cancel-btn" @click="close_accessory_detail">Cancel</button>
                    <button class="confirm-btn" @click="confirm_color_detail">Confirm Selection</button>
                </div>
            </div>
        </popup>

    </div>
</template>

<script>
    import {
    AccessoryCategoryList,
    AccessoryLabelList,
    AccessoryList,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import axios from "axios";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from 'vuex';
import Lesson from "./Lesson.vue";

    export default {
        name: "Accessory",
        data() {
            return {
                swiperOption: {
                    loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
                    autoplay: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    on: {
                        slideChange: function () {
                            if(document.getElementById('video-accessory')) {
                                if(this.activeIndex === 0) {
                                    document.getElementById('video-accessory').play()
                                } else {
                                    document.getElementById('video-accessory').pause()
                                }
                            }
                        },
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                },
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                form_data_accessory: {
                    page: 1,
                    size: 20,
                    keyword: "",
                    accessory_category_id: 0,
                },
                total: -1,
                accessory_label_list: [],
                accessory_label_ids: [],
                sub_accessory_category_list: [],
                accessory_category_list: [],
                accessory_list: [],
                current_accessory_category_id: 0,
                current_sub_accessory_category_id: 0,
                current_temp_accessory: {
                    image_list: [],
                },
                is_popup_show_detail: false,
                is_color_show: false,
                current_tab1: "default",
                width: '600px'
            }
        },
        components: {
            Popup,
            swiper,
            swiperSlide,
            Lesson
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
                product_category_list: (state) => state.design.product_category_list,
            }),
            selected_ids() {
                return this.form_data.accessory.map(v=>v.id)
            },
        },
        methods: {
            change_tab1(c) {
                this.current_tab1 = c;
            },
            choose_label(v) {
                if (this.accessory_label_ids.includes(v.id)) {
                    this.accessory_label_ids = this.accessory_label_ids.filter((item) => {
                        return item !== v.id;
                    });
                } else {
                    this.accessory_label_ids.push(v.id);
                    this.accessory_label_ids = [...new Set(this.accessory_label_ids)];
                }
                this.form_data_accessory.page = 1
                this.getAccessoryList();
            },
            del_accessory(k) {
                this.$DModal.confirm({
                    content: 'Do you want to cancel the selected data?',
                    okText:'Confirm',
                    cancelText:'Cancel',
                    onOK: async () => {
                        this.$store.commit('design/arr_remove_one', {key: 'accessory', index: k})
                    }
                })
            },
            toggle_accessory(v) {
                if(this.selected_ids.includes(v.id)) {
                    let idx = this.form_data.accessory.findIndex(obj => obj.id===v.id)
                    this.del_accessory(idx)
                } else {
                    this.open_color_modal(v)
                }
            },
            open_color_modal(accessory) {
                this.current_temp_accessory = Object.assign({}, accessory);
                if (this.current_temp_accessory.color_list.length > 1) {
                    this.is_color_show = true;
                } else if (this.current_temp_accessory.color_list.length === 0) {
                    this.choose_color({color_name_en: "", color_value: "", color_key: ""})
                    this.confirm_color()
                } else {
                    this.choose_color(this.current_temp_accessory.color_list[0])
                    this.confirm_color()
                }
            },
            choose_color(v) {
                this.$set(this.current_temp_accessory, "color_name_en", v.color_name_en);
                this.$set(this.current_temp_accessory, "color_value", v.color_value);
                this.$set(this.current_temp_accessory, "color_key", v.color_key);
                this.$set(this.current_temp_accessory, "color_id", v.color_id)
            },
            confirm_color() {
                if(this.form_data.accessory.length + this.form_data.accessory_self.length >= 10) {
                    this.$layer.msg(`You can add up to 10 accessories`)
                    return
                }
                let object = {...this.current_temp_accessory, desc: "", num: 1}
                this.$store.commit("design/arr_push_one", {key: 'accessory', value: object})
                this.is_color_show = false;
                this.reset_temp_accessory()
            },
            confirm_color_detail() {
                if(this.form_data.accessory.length + this.form_data.accessory_self.length >= 10) {
                    this.$layer.msg(`You can add up to 10 accessories`)
                    return
                }
                let object = {...this.current_temp_accessory, desc: "", alias: ""}
                this.$store.commit("design/arr_push_one", {key: 'accessory', value: object})
                this.is_popup_show_detail = false;
                this.reset_temp_accessory()
            },
            close_color_modal() {
                this.is_color_show = false;
                this.reset_temp_accessory()
            },
            add_accessory_self() {
                if(this.form_data.accessory.length + this.form_data.accessory_self.length >= 10) {
                    this.$layer.msg(`You can add up to 10 accessories`)
                    return
                }
                let object = {image: "", accessory_sku: "", accessory_name: "", measure_unit_en: "", num:'', desc: "",}
                this.$store.commit("design/arr_push_one", {key: 'accessory_self', value: object})
            },
            del_accessory_self(k) {
                this.$store.commit('design/arr_remove_one', {key: 'accessory_self', index: k})
            },
            open_accessory_detail(v) {
                this.current_temp_accessory = v;
                if(this.current_temp_accessory.color_list.length === 1){
                    this.choose_color(this.current_temp_accessory.color_list[0])
                }
                this.is_popup_show_detail = true;
            },
            close_accessory_detail() {
                this.reset_temp_accessory()
                this.is_popup_show_detail = false;
            },
            reset_temp_accessory() {
                this.current_temp_accessory = {image_list: []};
            },
            changePage(page) {
                this.form_data_accessory.page = page
                this.getAccessoryList()
            },
            search_accessory() {
                this.getAccessoryList();
            },
            choose_accessory_category(category) {
                this.current_accessory_category_id =
                    this.form_data_accessory.accessory_category_id = category.accessory_category_id;
                if (category.accessory_category_id === 0) {
                    this.sub_accessory_category_list = [];
                } else {
                    this.sub_accessory_category_list = category.children;
                }
                this.current_sub_accessory_category_id = 0;
                this.form_data_accessory.page = 1
                this.getAccessoryList();
            },
            choose_sub_accessory_category(category) {
                this.current_sub_accessory_category_id =
                    this.form_data_accessory.accessory_category_id = category.accessory_category_id;
                this.form_data_accessory.page = 1
                this.getAccessoryList();
            },
            async getAccessoryCategoryList() {
                return AccessoryCategoryList().then((response) => {
                    this.accessory_category_list = [
                        { category_name_en: "All", accessory_category_id: 0 },
                        ...response.data,
                    ];
                    return response;
                });
            },
            async getAccessoryLabelList() {
                return AccessoryLabelList().then((response) => {
                    this.accessory_label_list = [...response.data];
                    return response;
                });
            },
            async getAccessoryList() {
                return AccessoryList({
                    ...this.form_data_accessory,
                    label_id: this.accessory_label_ids,
                }).then((response) => {
                    this.accessory_list = response.data.list;
                    this.total = response.data.total;
                    return response;
                });
            },
            input2($event, field, k, child_field) {
                let object = this.form_data[field][k]
                object[child_field] = $event.target.value
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
            change3($event, field, k, child_field) {
                let object = this.form_data[field][k]
                let o = object.color_list.find(v=>v.color_key == $event.target.value)
                if(o) {
                    object[child_field] = $event.target.value
                    object[`color_name_en`] = o.color_name_en
                    object[`color_value`] = o.color_value
                }
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
            handleSuccess(response, file, fileList, k) {
                let object = this.form_data.accessory_self[k]
                object.image = response.data.url;
                this.$store.commit('design/arr_update_one', {key: 'accessory_self', index: k, value: object})
            },
        },
        mounted() {
            this.width = window.innerWidth - 220 - 490 - 30 + 'px'
            axios.all([
                this.getAccessoryCategoryList(),
                this.getAccessoryLabelList(),
            ]).then(
                axios.spread(() => {
                    this.getAccessoryList();
                })
            )
        }
    }
</script>

<style scoped lang="scss">
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;

        .left {
            padding: 0 30px 100px 30px;
            width: 490px;
            background: white;
            overflow: auto;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .tab-list {
                margin-top: 20px;
                width: 100%;
                padding-bottom: 15px;
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                border-bottom: 1px solid #E6E6E6;
                .tab-item {
                    // width: 110px;
                    flex:1;
                    color: #4D4D4D;
                    font-size: 14px;
                    text-align: center;
                    &.active {
                        font-weight: bold;
                        color: black;
                        font-size: 16px;
                    }
                }
                .shu {
                    width: 2px;
                    height: 20px;
                    margin: 0 10px;
                    background: #808080;
                }
            }
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 18px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 15px 0;
            }

            .tip3 {
                margin: 20px 0 10px 0;
                font-weight: bolder;
                font-size: 14px;
                color: red;
            }

            .mlist {
                display: flex;
                flex-wrap: wrap;
                margin: 10px 0;
                .item {
                    position: relative;
                    width: 420px;
                    margin-bottom: 10px;
                    padding: 10px;
                    border: 1px solid #BFBFBF;
                    border-radius: 5px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .img-wrap {
                        position: relative;
                        width: 100px;
                        height: 100px;
                        .img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                        select {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 70px;
                            height: 25px;
                            background: rgba(0, 0, 0, 0.5);
                            border-radius: 5px;
                            color: white;
                            z-index: 50;
                        }
                    }
                    .r1 {
                        width: 260px;
                        display: flex;
                        flex-wrap: wrap;
                        margin-left: 10px;
                        .name {
                            width: 260px;
                            color: #1D1D1D;
                            margin: 10px 0;
                            font-weight: bold;
                        }
                        .tag-list {
                            display: flex;
                            flex-wrap: wrap;
                            align-content: flex-start;
                            .tag-item {
                                width: 50%;
                                .key {
                                    color: #666;
                                }
                                .value {
                                    height: 30px;
                                    color: #1A1A1A;
                                    border: none;
                                    outline: none;
                                }
                                select {
                                    border: none;
                                    outline: none;
                                }
                            }
                        }
                    }

                    .form-group {
                        width: 400px;
                        height: 40px;
                        padding: 0 10px;
                        background: #F5F5F5;
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        .desc {
                            background: #F5F5F5;
                            margin-left: 10px;
                            width: 300px;
                            height: 40px;
                            line-height: 40px;
                            border: none;
                            outline: none;
                        }
                    }

                    .icon-del {
                        position: absolute;
                        top: 6px;
                        right: 6px;
                        width: 18px;
                        height: 18px;
                    }
                }
            }

            .mlist2 {
                display: flex;
                flex-wrap: wrap;
                margin: 10px 0;
                .item {
                    position: relative;
                    width: 420px;
                    margin-bottom: 10px;
                    padding: 10px;
                    border: 1px solid #BFBFBF;
                    border-radius: 5px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .img-wrap {
                        position: relative;
                        width: 100px;
                        height: 100px;
                        background: #F5F5F5;
                        .img-box{
                            position:relative;
                            width:100px;
                            height:100px;
                            .img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                            .replace-btn{
                                width:100px;
                                position:absolute;
                                bottom:11px;
                                left:50%;
                                transform:translateX(-50%);
                                background:rgba(0,0,0,0.4);
                                color:#ffffff;
                                font-size:13px;
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                cursor:pointer;
                                .ico{
                                    width:18px;
                                    height:18px;
                                    // color:#ffffff;
                                }
                                .text{}
                            }
                        }
                        select {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 70px;
                            height: 25px;
                            background: rgba(0, 0, 0, 0.5);
                            border-radius: 5px;
                            color: white;
                            z-index: 100;
                        }
                        .img-default {
                            width: 120px;
                            height: 120px;
                            display: flex;
                            justify-content: center;
                            align-content: center;
                            flex-wrap: wrap;
                            .img2 {
                                width: 22px;
                                height: 22px;
                            }
                            p {
                                width: 100%;
                                text-align: center;
                            }
                        }
                    }
                    .r1 {
                        width: 260px;
                        display: flex;
                        flex-wrap: wrap;
                        margin-left: 10px;
                        .tag-list {
                            display: flex;
                            flex-wrap: wrap;
                            align-content: flex-start;
                            .tag-item {
                                width: 100%;
                                border-bottom: 1px solid #E6E6E6;
                                display: flex;
                                flex-wrap: nowrap;
                                align-items: center;
                                .key {
                                    width: 50px;
                                    color: #666;
                                }
                                .value {
                                    height: 30px;
                                    color: #1A1A1A;
                                    border: none;
                                    outline: none;
                                }
                                select {
                                    border: none;
                                    outline: none;
                                }
                            }
                        }
                    }

                    .form-group {
                        width: 400px;
                        height: 40px;
                        padding: 0 10px;
                        background: #F5F5F5;
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        .desc {
                            background: #F5F5F5;
                            margin-left: 10px;
                            width: 300px;
                            height: 40px;
                            line-height: 40px;
                            border: none;
                            outline: none;
                        }
                    }

                    .icon-del {
                        position: absolute;
                        top: 6px;
                        right: 6px;
                        width: 18px;
                        height: 18px;
                    }
                }
                .btn-continue {
                    width: 420px;
                    height: 55px;
                    line-height: 55px;
                    color: #666666;
                    font-size: 14px;
                    text-align: center;
                    margin: 10px 0;
                    border-radius: 10px;
                    border: 1px solid #ccc;
                }
            }
        }

        .right {
            // margin: 0 auto;
            display:flex;
            flex-direction:column;
            flex:1;
            .material-wrap {
                margin-top: 10px;
                margin-right: 50px;
                padding: 10px;
                background: white;
                .top {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 5px;
                    border-bottom: 2px solid #f6f7fa;
                    h2 {
                        font-size: 20px;
                        color: #1a1a1a;
                        white-space: nowrap;
                    }

                    .input-wrap {
                        margin-left: 50px;
                        width: 280px;
                        height: 35px;
                        position: relative;

                        &:focus {
                            border: none !important;
                        }

                        &::after {
                            border: none !important;
                        }

                        input {
                            width: 100%;
                            height: 100%;
                            background: #f2f2f2;
                            border-radius: 17px;
                            padding: 0 45px 0 20px;
                            border: none !important;

                            &:focus {
                                border: none !important;
                            }

                            &::after {
                                border: none !important;
                            }
                        }

                        .icon-search {
                            position: absolute;
                            right: 18px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                        }
                    }
                }

                /* 主内容区 */
                .content {
                    display: flex;

                    /* 左侧分类 */
                    .category-list {
                        width: 100px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        align-content: flex-start;
                        border-right: 1px solid #f6f7fa;
                        overflow-y: auto;
                        padding: 15px 0;
                        max-height:650px;

                        .category-item {
                            width: 80px;
                            height: 35px;
                            line-height: 35px;
                            text-align: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #1C1C1C;
                            border-radius: 5px;
                            &.active {
                                background: #1C1C1C;
                                color: white;
                                font-weight: 500;
                            }
                        }
                    }

                    /* 右侧内容 */
                    .right-content {
                        $left_width: 140px;
                        width: calc(100% - #{$left_width});
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 10px;
                        overflow: hidden;

                        /* 标签筛选区 */
                        .label-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 12px 0;
                            margin-bottom: 5px;

                            .label-item {
                                padding: 0 15px;
                                height: 20px;
                                line-height: 20px;
                                border-radius: 15px;
                                //   background: #f6f6f6;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #ffecee;
                                    color: #fa3d5a;
                                    font-weight: 500;
                                }
                            }
                        }

                        /* 子分类 */
                        .sub-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            background: #f6f6f6;

                            .sub-item {
                                padding: 0 12px;
                                height: 28px;
                                line-height: 28px;
                                border-radius: 14px;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #fa3d5a;
                                    color: white;
                                }
                            }
                        }

                        .no-data {
                            width:300px;
                            height: auto;
                            display: block;
                            margin:0 auto;
                        }
                        /* 辅料列表 */
                        .fabric-list {
                            flex: 1;
                            display: grid;
                            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
                            border-radius: 5px;
                            // gap: 3px 0px;
                            // gap: 6px 0;
                            column-gap:55px;
                            row-gap:6px;
                            align-items: start;
                            overflow-y: auto;
                            padding: 15px;
                            background: #F6F7FA;
                            width:100%;
                            max-height:650px;

                            &::-webkit-scrollbar {
                                display: none !important;
                            }

                            .fabric-item {
                                position: relative;
                                // width: 142px;
                                flex:0 0 20%;
                                height: 175px;
                                margin: 0 5px 15px 5px;
                                cursor: pointer;
                                box-sizing: border-box;
                                border: 1px solid #e3e4e6;
                                border-radius: 5px;

                                img {
                                    // width: 140px;
                                    width:100%;
                                    height: 141px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;
                                    object-fit: contain;
                                }

                                p {
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    background: white;
                                    padding: 0 5px;
                                    border-top: 0.5px solid #e3e4e6;
                                    margin-top: -5px;
                                    text-align: center;
                                    border-bottom-left-radius: 5px;
                                    border-bottom-right-radius: 5px;
                                }

                                .icon-check {
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 25px;
                                    height: 25px;
                                }

                                &.active {
                                    border: 1px solid #fa3d5a;
                                }

                                .mask {
                                    display: none;
                                }

                                &:hover {
                                    .mask {
                                        display: block;
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        right: 0;
                                        height: 140px;
                                        z-index: 100;
                                        background: rgba(0, 0, 0, 0.35);

                                        .btn{
                                            display:flex;
                                            position:absolute;
                                            top:115px;
                                            right:10px;
                                            align-items:center;
                                            justify-content:end;
                                            column-gap:10px;
                                            .fa-detail {
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }

                                            .fa-choose {
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        /* 底部按钮 */
                        .btn-group {
                            display: flex;
                            justify-content: flex-end;
                            gap: 15px;
                            padding-top: 10px;

                            .btn {
                                min-width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                cursor: pointer;
                                transition: all 0.2s;
                                text-align: center;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }

                .color-mask {
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.35);
                    z-index: 9999;
                    .color-wrap {
                        position: absolute;
                        width: 600px;
                        height: 300px;
                        top:calc(50% - 150px);
                        left: calc(50% - 300px);
                        background: white;
                        border-radius: 10px;
                        z-index: 10000;
                        padding: 20px 10px 0 10px;

                        .title {
                            font-size: 16px;
                            font-weight: bold;
                            color: #1a1a1a;
                        }

                        .color-list {
                            display: flex;
                            flex-wrap: wrap;
                            width: 560px;
                            height:100%;
                            min-height: 150px;
                            max-height:170px;
                            overflow-y:auto;
                            row-gap:10px;

                            .color-item {
                                width: 120px;
                                height: 46px;
                                border: 1px solid #e5e5e5;
                                border-radius: 5px 5px 5px 5px;
                                margin: 0 8px;
                                display: flex;
                                align-items: center;
                                padding: 0 5px;
                                cursor: pointer;

                                img {
                                    width: 30px;
                                    height: 30px;
                                    margin-right: 5px;
                                }

                                &.active {
                                    border-color: #fa3d5a;

                                    span {
                                        color: #fa3d5a;
                                    }
                                }
                            }
                        }

                        .btn-group {
                            margin-top: 24px;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                            border-top: 1px solid #e5e5e5;
                            height: 58px;

                            .btn {
                                width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                text-align: center;
                                font-size: 14px;
                                margin: 0 7px;
                                cursor: pointer;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    @media (min-width:1280px) and (max-width:1679px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:100%;
                max-width:450px;
                margin-right:30px;
                height:100% !important;
                .mlist,.mlist2{
                    width:100%;
                    .item{
                        width:100%;
                        .img-wrap{
                            width:100px;
                            height:100px;
                            .img{
                                width:100%;
                                height:100%;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-default{
                                width:100%;
                                height:100px;
                            }
                        }
                        .r1{
                            width:255px;
                            .name{
                                margin:0;
                            }
                            .tag-list{
                                width:100%;
                                .tag-item{
                                    width:100%;
                                }
                            }
                        }
                        .form-group{
                            width:100%;
                            .desc{
                                width:auto;
                                flex:1;
                            }
                        }
                    }
                }
                .mlist2{
                    .item{
                        .img-wrap{
                            width:100px !important;
                            height:100px !important;
                            ::v-deep .ivu-upload{
                                width:100%;
                                height:100%;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-box{
                                width:100% !important;
                                height:100% !important;
                                .img{
                                    width:100% !important;
                                    height:100% !important;
                                    object-fit:cover;
                                }
                            }
                        }
                        .r1{
                            width:auto;
                            flex:1;
                            overflow:hidden;
                            .tag-list{
                                .tag-item{
                                    span{
                                        flex:1;
                                        flex-shrink:0;
                                    }
                                    input{
                                        width:210px;
                                    }
                                }
                            }
                        }

                    }

                }
            }
            .right{
                flex:1 1 auto;
                max-width:1100px;
                max-height:730px;
                flex-shrink:0;
                margin-right:0;
                margin-left:0;
                height:100%;
                .material-wrap{
                    height:100% !important;
                    margin-right:0;
                    .content{
                        .category-list{
                            min-width:100px;
                            max-height:700px;
                            overflow-y:scroll;
                        }
                        .right-content{
                            max-height:700px;
                            .fabric-list{
                                gap:6px 10px;
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width:1279px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:100%;
                max-width:350px;
                margin-right:10px;
                height:100% !important;
                .mlist,.mlist2{
                    width:100%;
                    .item{
                        width:100%;
                        overflow: hidden;
                        .img-wrap{
                            width:100px;
                            height:100px;
                            .img{
                                width:100%;
                                height:100%;
                            }
                            .img-default{
                                width:100%;
                                height:100px;
                            }
                        }

                        .form-group{
                            width:100%;
                            .desc{
                                width:auto;
                                flex:1;
                            }
                        }
                    }
                }
                .mlist{
                    .item{
                        .img-wrap{
                            width:100px !important;
                            height:100px !important;
                            ::v-deep .ivu-upload{
                                width:100%;
                                height:100%;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-box{
                                width:100% !important;
                                height:100% !important;
                                .img{
                                    width:100% !important;
                                    height:100% !important;
                                    object-fit:cover;
                                }
                            }
                        }
                        .r1{
                            width:150px;
                            .name{
                                margin:0;
                            }
                            .tag-list{
                                width:100%;
                                .tag-item{
                                    width:100%;
                                    .value{
                                        width:80px;
                                    }
                                }
                            }
                        }
                    }
                }
                .mlist2{
                    .item{
                        .img-wrap{
                            width:100px !important;
                            height:100px !important;
                            ::v-deep .ivu-upload{
                                width:100%;
                                height:100%;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-box{
                                width:100% !important;
                                height:100% !important;
                                .img{
                                    width:100% !important;
                                    height:100% !important;
                                    object-fit:cover;
                                }
                            }
                        }
                        .r1{
                            width:150px;
                            .name{
                                margin:0;
                            }
                            .tag-list{
                                width:100%;
                                .tag-item{
                                    width:100%;
                                    .value{
                                        width:100px;
                                    }
                                }
                            }
                        }
                        // .img-wrap{
                        //     .img-box{
                        //         width:100%;
                        //         height:100%;
                        //         .img{
                        //             width:100%;
                        //             height:100%;

                        //         }
                        //     }
                        // }
                    }

                }
            }
            .right{
                flex:1 1 auto;
                max-width:1100px;
                max-height:730px;
                flex-shrink:0;
                margin-right:0;
                margin-left:0;
                height:100%;
                .material-wrap{
                    height:100% !important;
                    margin-right:0;
                    .content{
                        .category-list{
                            min-width:100px;
                        }
                        .right-content{
                            max-height:700px;
                            .fabric-list{
                                gap:6px 10px;
                            }
                        }
                    }
                }
            }
        }
    }

    ::v-deep .ivu-upload-select{
        width:100%;
        height:100%;
    }

    ::v-deep .popup-modal {
        /* 核心容器 */
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 110;
        background: rgba(0, 0, 0, 0.6);

        /* 弹窗内容区 */
        .popup-content {
            background: #fff;
            border-radius: 10px;
            //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
            /* 修正后 */
            width: max(980px, 96vw); // 增加视口占比
            min-width: 320px; // 保障最小可操作宽度
            max-width: none !important; // 移除潜在限制

            /* 添加边距保护 */
            margin: 0 2vw; // 左右留白
            box-sizing: content-box; // 防止padding影响
            max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
            height: 30vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }

    .fabric-content-wrap {
        margin-top: 40px;
        overflow-y: scroll;
        // height: 600px;
        position:relative;
        display:flex;
        flex-direction:column;
        .title-box{
            display:flex;
            align-items: center;
            column-gap:13px;
            .title {
                color: #1a1a1a;
                font-size: 16px;
                border-left: none;
                font-weight: bold;
                margin-bottom: 0;
                padding: 10px 0;
                height: auto;
            }
            .line{
                flex:1;
                height:1px;
                background:#ebebeb;
            }
        }

        .info-wrap {
            display: flex;
            justify-content: space-around;

            .left-popup {
                width: 420px;
                border:1px solid #e5e5e5;
                .f-img {
                    width: 100%;
                    height: 420px;
                    object-fit:contain;
                }
            }

            .right {
                // width: 500px;
                flex:1;
                padding-right:20px;
                padding-left:20px;
                .name {
                    color: #1a1a1a;
                    font-size: 20px;
                }

                .no {
                    color: #808080;
                    font-size: 14px;
                    margin: 25px 0;
                }

                .item {
                    margin: 5px 0;

                    .key {
                        display: inline-block;
                        color: #808080;
                        width: 80px;
                    }

                    .value {
                        color: #1a1a1a;
                    }
                }
                .color-title{
                    color:#1a1a1a;
                    font-size:16px;
                    font-weight:bold;
                }
                .color-box{
                    width:100%;
                    display:flex;
                    flex-wrap:wrap;
                    row-gap:10px;
                    column-gap:10px;
                    margin-top:26px;
                    .color-item{
                        width:112px;
                        height:40px;
                        display: flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:6px;
                        border-radius:5px;
                        border:1px solid #e5e5e5;
                        color:#4d4d4d;
                        cursor:pointer;
                        .color-img{
                            width:25px;
                            height:25px;
                            border-radius:5px;
                        }
                        &.active{
                            border:1px solid #fa3d5a;
                            color:#fa3d5a;
                        }
                    }
                }
            }
        }

        .richtext-wrap {
            flex:1;
            padding-bottom:60px;
        }
        .btn-box{
            display:flex;
            justify-content:center;
            column-gap:20px;
            position:sticky;
            bottom:0;
            left:0;
            right:0;
            z-index:1;
            background:#ffffff;
            padding:10px 0;
            .cancel-btn{
                width:120px;
                height:38px;
                border-radius:19px;
                background:#ffffff;
                border:1px solid #e5e5e5;
                color:#1a1a1a;
                font-size:14px;
                cursor:pointer;
            }
            .confirm-btn{
                width:120px;
                height:38px;
                border-radius:19px;
                background:#1a1a1a;
                color:#ffffff;
                font-size:14px;
                cursor:pointer;
            }
        }
    }

    .slider {
        width: 420px;
        height: 420px;
        overflow: hidden;

        .swiper-slide {
            width: 420px;
            height: 420px;
        }

        .img, video {
            width: 420px;
            height: 420px;
            object-fit:contain;
        }
    }

    ::v-deep .viewer-container {
        z-index: 999999 !important;
        }
</style>
